import { z } from 'zod';

export const BaseOperationStepResult = z.looseObject({
  message: z.string().nullish(),
  publishResult: z.string().nullish(),
  warnings: z.string().array().nullish(),
  operationComplete: z.boolean().nullish(),
  waitingForChildOperations: z.boolean().nullish(),
});
export type BaseOperationStepResult = z.infer<typeof BaseOperationStepResult>;

export type TypeConfig<T extends string> = {
  steps: T[];
  hasChildOperations?: boolean;
  isTestOperation?: boolean;
};
export type StepConfig = {
  inputSchema: z.ZodType<object>;
  outputSchema: z.ZodType<BaseOperationStepResult>;
  // If true, the candidate parameter is required
  singleCandidate?: boolean;
  // If true, there may be multiple copies of this step on an operation
  isRepeatable?: boolean;
};
